import { toast, ToastOptions } from "react-hot-toast";

const baseOptions: ToastOptions = {
  position: "top-right",
  duration: 4000,
  style: {
    zIndex: 9999,
  },
};

export const showToast = {
  success: (message: string, options?: ToastOptions) =>
    toast.success(message, {
      ...baseOptions,
      ...options,
    }),

  error: (message: string, options?: ToastOptions) =>
    toast.error(message, {
      ...baseOptions,
      ...options,
    }),

  info: (message: string, options?: ToastOptions) =>
    toast(message, {
      ...baseOptions,
      icon: "ℹ️",
      ...options,
    }),

  warning: (message: string, options?: ToastOptions) =>
    toast(message, {
      ...baseOptions,
      icon: "⚠️",
      ...options,
    }),
};
